import { Location } from "../types";

const formatLocationAddress = (location: Location) => {
  const {
    core: { physicalAddress },
  } = location;
  let address = "";
  address += `${physicalAddress.address1}, `;
  if (physicalAddress.address2) address += `${physicalAddress.address2}, `;
  if (physicalAddress.address3) address += `${physicalAddress.address3}, `;
  address += `${physicalAddress.city}, ${physicalAddress.state} `;
  address += physicalAddress.zipCode.zip;
  return address;
};

export default formatLocationAddress;
